function scrollWindowToTop() {
    if (window && document && document.body) {
        // scroll to top when the route changes.
        window.scrollTo(0, 0);
    }
}

export default scrollWindowToTop;
